<template>
  <v-container fluid class="hub-hero-section primary py-8 py-md-16">
    <v-container>
      <v-row align="center" class="py-md-16">
        <v-col cols="12" md="8" class="mx-auto text-center">
          <span
            class="overline secondary--text font-weight-bold"
            data-aos="fade-down"
          >
            PLATAFORMA DE SOLUCIONES VERTICALES
          </span>
          <h1
            class="display-2 font-weight-bold white--text mb-6 mt-2"
            style="line-height: 1.2;"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Soluciones digitales especializadas para
            industrias que mueven el mundo
          </h1>
          <p
            class="text-h6 white--text mb-8 font-weight-light"
            style="line-height: 1.6;"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Cada vertical diseñada desde cero para el proceso
            específico de tu industria — no adaptaciones genéricas.
          </p>
          <div data-aos="fade-up" data-aos-delay="300">
            <v-btn
              :x-large="$vuetify.breakpoint.mdAndUp"
              :large="$vuetify.breakpoint.smAndDown"
              depressed
              color="secondary"
              class="mr-4 mb-4 white--text"
              href="#verticals"
              rounded
            >
              Explorar Soluciones
            </v-btn>
            <v-btn
              :x-large="$vuetify.breakpoint.mdAndUp"
              :large="$vuetify.breakpoint.smAndDown"
              outlined
              dark
              class="mb-4"
              href="#contact"
              rounded
            >
              Contactar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'HubHero',
};
</script>

<style lang="scss" scoped>
.hub-hero-section {
  background: linear-gradient(
    135deg,
    var(--v-primary-base) 0%,
    #1a3a5c 100%
  );
  position: relative;
  overflow: hidden;
}

.hub-hero-section::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(
    circle,
    rgba(255, 107, 53, 0.1) 0%,
    transparent 70%
  );
  border-radius: 50%;
}
</style>
